import * as React from "react";

function SvgIcChevronDown(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.707 8.293a1 1 0 010 1.414L13.414 17a2 2 0 01-2.828 0L3.293 9.707a1 1 0 011.414-1.414L12 15.586l7.293-7.293a1 1 0 011.414 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcChevronDown;
